"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ngc(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M15 12.6315L9.978 19.5L10.1632 13.9193H9L9.4755 9.02025L14.7885 8.28825L13.044 12.732L15 12.6315ZM10.8765 17.505V16.1925C10.8765 16.095 10.794 16.0155 10.692 16.0155C10.59 16.0155 10.5067 16.0943 10.5067 16.1918V17.505C10.5067 17.6025 10.5892 17.682 10.692 17.682C10.7947 17.682 10.8765 17.6025 10.8765 17.505ZM9.5025 13.5405H10.56L10.5113 15.5602C10.5105 15.6135 10.5315 15.6652 10.5705 15.7028C10.6095 15.7403 10.6628 15.7628 10.7183 15.7628H10.7273C10.7801 15.7638 10.8312 15.7441 10.8698 15.708C10.9083 15.6718 10.9312 15.622 10.9335 15.5693L10.9822 13.1865H9.92475L10.2795 9.27225C10.2833 9.22725 10.2675 9.18225 10.2353 9.1485C10.203 9.11475 10.158 9.096 10.11 9.096H10.08C10.0384 9.09516 9.99805 9.10982 9.96672 9.13714C9.93538 9.16446 9.91534 9.20246 9.9105 9.24375L9.5025 13.5405ZM9.5025 8.5905L11.4585 6.975C11.5635 5.35875 10.506 5.106 10.506 5.106L10.665 4.5C12.4095 5.00475 12.1455 6.924 12.1455 6.924L14.6827 7.9845L9.5025 8.5905Z", fill: color }));
}
exports["default"] = ngc;
//# sourceMappingURL=ngc.js.map